<template>
  <div class="col-md-6" v-if="!editing">
    <div>
      <ul>
	      <li v-if="decodedRepresentative.moral_person"><strong>{{decodedRepresentative.corporation_name}}</strong> représenté par</li>
        <li class="bold name">{{decodedRepresentative.title}}</li>
        <li>{{decodedRepresentative.decoded_representative_quality}}</li>
        <li>{{decodedRepresentative.street_line1}}</li>
        <li v-if="decodedRepresentative.street_line2">{{decodedRepresentative.street_line2}}</li>
        <li>{{decodedRepresentative.zipcode}} {{decodedRepresentative.city}}</li>
        <li v-if="decodedRepresentative.decoded_state">{{decodedRepresentative.decoded_state}}</li>
        <li v-if="decodedRepresentative.decoded_country">{{decodedRepresentative.decoded_country}}</li>
      </ul>
      <div v-if="decodedRepresentative.email || decodedRepresentative.phone || decodedRepresentative.mobile_phone"
        class="representative-supplemental-info">
        <ul>
          <li v-if="decodedRepresentative.email">Email : <a :href="'mailto:' + decodedRepresentative.email">{{decodedRepresentative.email}}</a></li>
          <li v-if="decodedRepresentative.phone">Tel : {{decodedRepresentative.phone}}</li>
          <li v-if="decodedRepresentative.mobile_phone">Mobile : {{decodedRepresentative.mobile_phone}}</li>
          <!-- <li>Alertes : Activées</li> -->
        </ul>
      </div>
      <ul v-if="isTerminated">
        <li>
          <span class="label label-danger">
            Démissionaire au {{decodedRepresentative.representative_end_date | moment-date}}
          </span>
        </li>
      </ul>
    </div>
    <div class="button" v-if="isProspect">
      <button class="btn btn-sm" @click="askForEdition">Modifier</button>
      <button class="btn btn-sm btn-danger" @click="askForDeletion">Supprimer</button>
    </div>
    <div class="cold-md-6 pull-right" v-else-if="!isTerminated">
      <button class="btn btn-sm" @click="askForAddressEdition">Modifier adresse</button>
      <button class="btn btn-sm" @click="askForInfoEdition">Modifier infos</button>
      <button class="btn btn-sm terminate btn-warning">Démissioner</button>
      <!-- $emit('mainify') -->
      <button class="btn btn-sm btn-warning" @click="$emit('show-mainify')">Définir comme principal</button>

      </div>
    <hr>
  </div>
  <div class="col-md-6" v-else>
    <div v-if="!isProspect">
      <resource-form v-if="edition.info" :model="form.model" :triggers="form.triggers"
        :schema="form.schema" @submit="handleRepresentativeEdition($event, 'info')">
        <button slot="cancel" class="btn btn-sm btn-danger" @click="$emit('cancel-edit')">Annuler</button>
      </resource-form>
      <resource-form v-if="edition.address" :model="form.model" :triggers="form.triggers"
        :schema="form.schema" @submit="handleRepresentativeEdition($event, 'address')">
        <button slot="cancel" class="btn btn-sm btn-danger" @click="$emit('cancel-edit')">Annuler</button>
      </resource-form>
    </div>
    <div v-else>
      <resource-form :model="form.model" :schema="form.schema" :triggers="form.triggers" @submit="handleRepresentativeEdition">
        <button slot="cancel" class="btn btn-sm btn-danger" @click="$emit('cancel-edit')">Annuler</button>
      </resource-form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  div {
    position: relative;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      line-height: 1.2rem;
    }
  }

  .name {
    font-size: 0.9rem;
  }

  .button {
    position: absolute;
    right: 0;
    bottom: 40px;
  }

  .representative-supplemental-info { margin-top: 10px; }
</style>

<script type="text/babel">
import representative from 'mixins/representative'
import representatives from 'mixins/representatives'
import ResourceForm from "components/Forms/ResourceForm"


export default {

  mixins: [ representatives, representative, ],

  components: {
    ResourceForm,
  },

}
</script>



// WEBPACK FOOTER //
// client/components/Customer/RepresentativesContent/OtherRepresentatives.vue